<template>
  <div id="app">
    <router-view class="content" />
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="scss">
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
  }

  *,
  *:hover,
  *:active,
  *:focus {
    outline: 0;
    -webkit-user-select: none;
    text-decoration: none;
    color: inherit;
  }

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #app {
    .content {
      width: 1366px;
      height: 1024px;
      background-size: cover;
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue